export const DSS_ACTION_STATES = {
    RECEIVED: 'received',
    PROCESSING: 'processing',
    SHIPPED: 'shipped',
    PARTIALLY_SHIPPED: 'partiallyShipped',
    DELIVERED: 'delivered',
    PARTIALLY_DELIVERED: 'partiallyDelivered',
    DELIVERED_FINAL_SALE: 'deliveredFinalSale',
    DELIVERED_RETURN_CLOSED: 'deliveredReturnClosed',
    CANCELLED_BY_SYSTEM: 'cancelledBySystem',
    CANCELLED_BY_CUSTOMER: 'cancelledByCustomer',
    PARTIALLY_CANCELLED_BY_SYSTEM: 'partiallyCancelledBySystem',
    PARTIALLY_CANCELLED_BY_CUSTOMER: 'partiallyCancelledByCustomer',
    PENDING_RETURN: 'pendingReturn',
    PARTIALLY_RETURNED: 'partiallyReturned',
    REFUNDED: 'refunded'
}

export const DSS_ACTION_BUTTONS = {
    CANCEL: 'cancel',
    UPDATE_SHIPPING: 'updateShipping',
    TRACK: 'track',
    RETURN: 'return'
}

export const DSS_ACTION_STATE_CONFIG = {
    [DSS_ACTION_STATES.RECEIVED]: {
        message: null,
        description: 'received',
        buttons: [DSS_ACTION_BUTTONS.CANCEL, DSS_ACTION_BUTTONS.UPDATE_SHIPPING]
    },
    [DSS_ACTION_STATES.PROCESSING]: {
        message: 'processing',
        description: 'processing',
        buttons: []
    },
    [DSS_ACTION_STATES.SHIPPED]: {
        message: null,
        description: 'shipped',
        buttons: [DSS_ACTION_BUTTONS.TRACK, DSS_ACTION_BUTTONS.RETURN]
    },
    [DSS_ACTION_STATES.PARTIALLY_SHIPPED]: {
        message: null,
        description: 'partiallyShipped',
        buttons: [DSS_ACTION_BUTTONS.TRACK, DSS_ACTION_BUTTONS.RETURN]
    },
    [DSS_ACTION_STATES.DELIVERED]: {
        message: null,
        description: 'delivered',
        buttons: [DSS_ACTION_BUTTONS.TRACK, DSS_ACTION_BUTTONS.RETURN]
    },
    [DSS_ACTION_STATES.PARTIALLY_DELIVERED]: {
        message: null,
        description: 'partiallyDelivered',
        buttons: [DSS_ACTION_BUTTONS.TRACK, DSS_ACTION_BUTTONS.RETURN]
    },
    [DSS_ACTION_STATES.DELIVERED_FINAL_SALE]: {
        message: 'delivered',
        description: 'deliveredFinalSale',
        buttons: [DSS_ACTION_BUTTONS.TRACK]
    },
    [DSS_ACTION_STATES.DELIVERED_RETURN_CLOSED]: {
        message: 'deliveredReturnClosed',
        description: 'deliveredReturnClosed',
        buttons: [DSS_ACTION_BUTTONS.TRACK]
    },
    [DSS_ACTION_STATES.CANCELLED_BY_SYSTEM]: {
        message: 'cancelledBySystem',
        description: 'cancelledBySystem',
        buttons: []
    },
    [DSS_ACTION_STATES.CANCELLED_BY_CUSTOMER]: {
        message: 'cancelledByCustomer',
        description: 'cancelledByCustomer',
        buttons: []
    },
    [DSS_ACTION_STATES.PARTIALLY_CANCELLED_BY_SYSTEM]: {
        message: 'partiallyCancelledBySystem',
        description: 'partiallyCancelledBySystem',
        buttons: [DSS_ACTION_BUTTONS.TRACK, DSS_ACTION_BUTTONS.RETURN]
    },
    [DSS_ACTION_STATES.PARTIALLY_CANCELLED_BY_CUSTOMER]: {
        message: 'partiallyCancelledByCustomer',
        description: 'partiallyCancelledByCustomer',
        buttons: [DSS_ACTION_BUTTONS.TRACK, DSS_ACTION_BUTTONS.RETURN]
    },
    [DSS_ACTION_STATES.PENDING_RETURN]: {
        message: 'pendingReturn',
        description: 'pendingReturn',
        buttons: [DSS_ACTION_BUTTONS.TRACK, DSS_ACTION_BUTTONS.RETURN]
    },
    [DSS_ACTION_STATES.PARTIALLY_RETURNED]: {
        message: 'partiallyReturned',
        description: 'partiallyReturned',
        buttons: [DSS_ACTION_BUTTONS.TRACK]
    },
    [DSS_ACTION_STATES.REFUNDED]: {
        message: 'refunded',
        description: 'refunded',
        buttons: [DSS_ACTION_BUTTONS.TRACK]
    }
}

const LEGACY_STATUS_FLAGS = [
    ['Released', DSS_ACTION_STATES.PROCESSING],
    ['Partially Released', DSS_ACTION_STATES.PROCESSING],
    ['Back Ordered', DSS_ACTION_STATES.PROCESSING],
    ['Partially Fulfilled', DSS_ACTION_STATES.PARTIALLY_SHIPPED],
    ['Picked', DSS_ACTION_STATES.PROCESSING],
    ['Packed', DSS_ACTION_STATES.PROCESSING],
    ['Allocated', DSS_ACTION_STATES.RECEIVED],
    ['Canceled', DSS_ACTION_STATES.CANCELLED_BY_SYSTEM],
    ['Received', DSS_ACTION_STATES.RECEIVED],
    ['Shipped', DSS_ACTION_STATES.SHIPPED],
    ['Fulfilled', DSS_ACTION_STATES.SHIPPED],
    ['Partially Shipped', DSS_ACTION_STATES.PARTIALLY_SHIPPED],
    ['Partially Delivered', DSS_ACTION_STATES.PARTIALLY_DELIVERED],
    ['Delivered', DSS_ACTION_STATES.DELIVERED],
    ['Cancelled', DSS_ACTION_STATES.CANCELLED_BY_CUSTOMER],
    ['Partially Cancelled', DSS_ACTION_STATES.PARTIALLY_CANCELLED_BY_SYSTEM],
    ['Partially Cancelled', DSS_ACTION_STATES.PARTIALLY_CANCELLED_BY_CUSTOMER],
    ['Pending Return', DSS_ACTION_STATES.PENDING_RETURN],
    ['Partially Returned', DSS_ACTION_STATES.PARTIALLY_RETURNED],
    ['Returned', DSS_ACTION_STATES.REFUNDED]
]

export const getDSSActionState = (order) => {
    const orderRawStatus = order?.statusRaw
    const isDeliveredReturnPeriodEnded = order?.actionsCTA?.isDeliveredReturnPeriodEnded
    const isDeliveredFinalSale = order?.actionsCTA?.isDeliveredFinalSale
    if (orderRawStatus === 'Delivered' && isDeliveredReturnPeriodEnded) {
        return DSS_ACTION_STATES.DELIVERED_RETURN_CLOSED
    }
    if (orderRawStatus === 'Delivered' && !isDeliveredReturnPeriodEnded && !isDeliveredFinalSale) {
        return DSS_ACTION_STATES.DELIVERED
    }
    if (orderRawStatus === 'Delivered' && !isDeliveredReturnPeriodEnded && isDeliveredFinalSale) {
        return DSS_ACTION_STATES.DELIVERED_FINAL_SALE
    }

    const legacyMatch = LEGACY_STATUS_FLAGS.find(([flag]) => orderRawStatus === flag)
    if (legacyMatch) {
        return legacyMatch[1]
    }
}

export const getDSSActionConfig = (order) => {
    const state = getDSSActionState(order)

    return {
        state,
        ...(DSS_ACTION_STATE_CONFIG[state] || {
            message: null,
            description: null,
            buttons: []
        })
    }
}
